<template>
    <sa-page-layout btnRefreshVisible AdiAccessiPageList>
        <!-- <template slot="toolbar">
      <b-button @click="onOpenModalDatiDocumenti" size="sm" class="float-sm-right" variant="success btn-toolbar"> <b-icon icon="plus"></b-icon>Nuovo</b-button>
    </template> -->
        <template slot="table-filter">
        </template>
        <template slot="table-body">
            <AdiMagazzinoListComponent />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import AdiMagazzinoListComponent from "../components/AdiMagazzinoListComponent.vue"
export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, AdiMagazzinoListComponent },

    data() {
        return {
        };
    },
    mounted() {

    },
    methods: {

    },
};
</script>

<style></style>
